/**
 * Page Loading Skeleton
 *
 * Neutral, route-agnostic placeholder shown by `ClubGate` while club data
 * loads. It deliberately avoids page-specific shapes (date pickers, time
 * grids) so it reads as "page loading" on booking, subscription, and
 * confirmation routes alike. Pages render their own content-shaped skeletons
 * for their own data once mounted.
 *
 * @module ui/layout
 */

import { Skeleton } from '@butter/ui/primitives';
import { SectionSkeleton } from '@butter/ui/components';

export function PageLoadingSkeleton() {
  return (
    <div aria-busy="true" aria-live="polite" data-testid="page-loading-skeleton">
      <span className="sr-only">Loading…</span>

      {/* Page header (title + subtitle) */}
      <div className="mb-8 space-y-2">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-5 w-80" />
      </div>

      {/* Two neutral content sections */}
      <div className="space-y-8">
        <SectionSkeleton showSubtitle />
        <SectionSkeleton />
      </div>
    </div>
  );
}
